import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageBoxComponent } from 'src/app/modals/message-box/message-box.component';
import { DocumentosService } from 'src/app/services/documentos.service';

@Component({
  selector: 'app-vista-documento',
  templateUrl: './vista-documento.component.html',
  styleUrls: ['./vista-documento.component.scss']
})
export class VistaDocumentoComponent implements OnInit {
  formulario:UntypedFormGroup=new UntypedFormGroup({
    categoria:new UntypedFormControl("",[Validators.required]),
    subcategoria:new UntypedFormControl("",[Validators.required]),
    tipo_documento:new UntypedFormControl("",[Validators.required]),
    documentoRuta:new UntypedFormControl("",[Validators.required]),
    // documentoRuta:new FormControl("",[]),
    nombre:new UntypedFormControl("",[Validators.required]),
    descripcion:new UntypedFormControl("",[]),
    fecha_alta:new UntypedFormControl("",[Validators.required]),
    documento:new UntypedFormControl("",[]),

  });
  isLoading=false;
  tipo_documentos:any=[];
  fileToUpload:any;
  id=null;
  categorias:any=[];
  subcategorias:any=[];
  tipoDocumentos:any=[];

  constructor(private dialog:MatDialog,private documentos_service:DocumentosService,private router:Router,private activatedRoute:ActivatedRoute) { 
    this.isLoading=true;
    this.documentos_service.getCatalogos().subscribe(result=>{
      let id_categorias = [];
      let id_subcategorias = [];
      let id_tipo_docto = [];
      for(let i=0;i<result.data.catalogo.length;i++){
        this.isLoading=false;
        if(id_categorias.indexOf(result.data.catalogo[i].id_categoria)==-1){
          id_categorias.push(result.data.catalogo[i].id_categoria);
          this.categorias.push({"id":result.data.catalogo[i].id_categoria,"nombre":result.data.catalogo[i].categoria});
        }
        if(id_subcategorias.indexOf(result.data.catalogo[i].id_subcategoria)==-1){
          id_subcategorias.push(result.data.catalogo[i].id_subcategoria);
          this.subcategorias.push({"id":result.data.catalogo[i].id_subcategoria,"nombre":result.data.catalogo[i].subcategoria,"id_categoria":result.data.catalogo[i].id_categoria});
        }
        if(id_tipo_docto.indexOf(result.data.catalogo[i].id_tipo_documento)==-1){
          id_tipo_docto.push(result.data.catalogo[i].id_tipo_documento);
          this.tipoDocumentos.push({"id":result.data.catalogo[i].id_tipo_documento,"nombre":result.data.catalogo[i].tipo_documento,"id_subcategoria":result.data.catalogo[i].id_subcategoria});
        }
      }
      // console.log("tipoDocumentos: ", this.tipoDocumentos);
    },()=>{
      this.isLoading=false;
    })
  }

  documento;
  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe(params=>{
      if(params['id']){
        this.id=params['id'];
        this.documentos_service.buscaDocumentos("",0,0,params['id'],null).subscribe(result=>{
          this.documento = result.data.documentos[0];
          this.formulario.controls["nombre"].setValue(this.documento.nombre);
          this.formulario.controls["nombre"].disable();
          this.formulario.controls["descripcion"].setValue(this.documento.descripcion);
          this.formulario.controls["descripcion"].disable();
          this.formulario.controls["fecha_alta"].setValue(new Date(this.documento.fecha_alta));
          this.formulario.controls["fecha_alta"].disable();
          this.formulario.controls["categoria"].setValue(this.documento.categoria);
          this.formulario.controls["categoria"].disable();
          this.formulario.controls["subcategoria"].setValue(this.documento.subcategoria);
          this.formulario.controls["subcategoria"].disable();
          this.formulario.controls["tipo_documento"].setValue(this.documento.id_tipo_docto);
          this.formulario.controls["tipo_documento"].disable();
          this.formulario.controls["documentoRuta"].setValue(this.documento.descargar);
          this.formulario.controls["documentoRuta"].disable();
          
        })
      }
    });
  }
  handleFileInput(files: FileList) {
    this.formulario.controls["documentoRuta"].setValue(files.item(0).name);
    this.formulario.controls["documento"].setValue(files.item(0));
  }

  changeSelectDocumentType(optionSelected: any){
    console.log("Entrando a change");
    let optSel = optionSelected.value;
    console.log("optSel: ", optSel);
    if(optSel == 15){
      console.log("Es Copy & Paste");
      this.formulario.controls['documentoRuta'].clearValidators();
      this.formulario.controls['documentoRuta'].updateValueAndValidity();
      
    }else{
      console.log("No Es Copy & Paste");
      this.formulario.controls['documentoRuta'].setValidators([Validators.required]);
      this.formulario.controls['documentoRuta'].updateValueAndValidity();
    }
  }
}
